import { render, staticRenderFns } from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=template&id=22a4bc5c&scoped=true"
import script from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=style&index=0&id=22a4bc5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4bc5c",
  null
  
)

export default component.exports